import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const PERMISSION_LIST_URL = "agency/admin/permissions-list/";

export const fetchPermissionList = createAsyncThunk(
  "permission/fetchPermissionList",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
      if (!token) {
        return;
      }

      const response = await axios.get(PERMISSION_LIST_URL, {
        params,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch users list"
      );
    }
  }
);

const initialState = {
  permission_list: [],
  error: false,
  loading: false,
};

const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPermissionList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPermissionList.fulfilled, (state, action) => {
        state.loading = false;
        state.permission_list = action.payload;
      })
      .addCase(fetchPermissionList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
        state.data = [];
      });
  },
});

export default permissionSlice.reducer;
